import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, UniqueEntityID } from '@digibricks/core';
import { CorrectAnswer } from './correct-answer';
import { Score } from '../score';
export var FillInBlankCorrectAnswer = /*#__PURE__*/function (_CorrectAnswer) {
  _inherits(FillInBlankCorrectAnswer, _CorrectAnswer);

  var _super = _createSuper(FillInBlankCorrectAnswer);

  function FillInBlankCorrectAnswer() {
    _classCallCheck(this, FillInBlankCorrectAnswer);

    return _super.apply(this, arguments);
  }

  _createClass(FillInBlankCorrectAnswer, [{
    key: "score",
    get: function get() {
      return this.props.score.value;
    }
  }, {
    key: "index",
    get: function get() {
      return this.props.index;
    }
  }, {
    key: "clone",
    value: function clone() {
      return FillInBlankCorrectAnswer.create(_objectSpread({}, this.props)).getValue();
    }
  }, {
    key: "updateScore",
    value: function updateScore(score) {
      this.props.score = Score.create(score).getValue();
      return Result.ok();
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread(_objectSpread(_objectSpread({}, _get(_getPrototypeOf(FillInBlankCorrectAnswer.prototype), "toJsonObject", this).call(this)), this.props), {}, {
        score: this.props.score.value
      });
    }
  }], [{
    key: "create",
    value: function create(props) {
      var resultOrError = this.validate(props);

      if (resultOrError.isFailure) {
        return Result.fail(resultOrError.error);
      }

      var guardCollections = [{
        argument: props.score,
        argumentName: 'Correct Answer Score'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        var _guardResult$message;

        return Result.fail((_guardResult$message = guardResult.message) !== null && _guardResult$message !== void 0 ? _guardResult$message : 'Error');
      }

      return Result.ok(new FillInBlankCorrectAnswer(props, new UniqueEntityID(props.id)));
    }
  }]);

  return FillInBlankCorrectAnswer;
}(CorrectAnswer);